import { render, staticRenderFns } from "./1_ask.vue?vue&type=template&id=e6c759b8&scoped=true&"
import script from "./1_ask.vue?vue&type=script&lang=js&"
export * from "./1_ask.vue?vue&type=script&lang=js&"
import style0 from "./1_ask.vue?vue&type=style&index=0&id=e6c759b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c759b8",
  null
  
)

export default component.exports